<template>
  <v-container clipped fill-height fixed fluid class="pa-0">
    <v-global-progress-bar namespace="ner" :flags="progressBarFlags" />
    <v-ner-toolbar />
    <v-sidebar-features />
    <v-layout>
      <v-products-grid />
    </v-layout>
  </v-container>
</template>

<script>
import VGlobalProgressBar from "@/components/progress/GlobalProgressBar.vue";
import VProductsGrid from "./components/products/Layout.vue";
import VSidebarFeatures from "./components/sidebar/Layout.vue";
import VNerToolbar from "./components/toolbar/Layout.vue";

export default {
  components: {
    VGlobalProgressBar,
    VProductsGrid,
    VSidebarFeatures,
    VNerToolbar
  },
  data: () => ({
    progressBarFlags: [
      "loadingAddTaggedFeatureToProduct",
      "loadingClassifications",
      "loadingCreateFeature",
      "loadingFeatures",
      "loadingProducts",
      "loadingRemoveTaggedFeature"
    ]
  })
};
</script>
